type CleanupFn = () => void;

interface PollUntilOptions {
  condition: () => boolean;
  onConditionMet: () => void;
  intervalMs?: number;
}

export function pollUntil({
  condition,
  onConditionMet,
  intervalMs = 100,
}: PollUntilOptions): CleanupFn {
  const intervalId = setInterval(() => {
    if (condition()) {
      clearInterval(intervalId);
      onConditionMet();
    }
  }, intervalMs);

  return () => clearInterval(intervalId);
}
